module.exports = __webpack_public_path__ + "img/horizontal_7_1_8003.99137aff.png";